import { render, staticRenderFns } from "./MultimediaCenterVideo.vue?vue&type=template&id=050efe20&scoped=true&"
import script from "./MultimediaCenterVideo.vue?vue&type=script&lang=js&"
export * from "./MultimediaCenterVideo.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaCenterVideo.vue?vue&type=style&index=0&id=050efe20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050efe20",
  null
  
)

export default component.exports